<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2Codes">
                    <el-select v-model="queryCondition.category2Codes" @change="changeCategory2" multiple clearable placeholder="请选择(支持多选)" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Codes">
                    <el-select v-model="queryCondition.category3Codes" multiple clearable placeholder="请选择(支持多选)" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Facility名称" prop="name">
                    <el-input v-model="queryCondition.name" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="供应商集团名称" prop="groupName">
                    <el-input v-model="queryCondition.groupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <ic-select clearable table="TM_QSPI_FACILITY" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row" v-if="ms_roles.indexOf('QSPI_MASTER_ADMIN')!==-1">
        <el-button size="mini" class="btn" type="primary" @click="onCreate" v-acl="QSPI_FACILITY_GEN_TASK">生成评分任务</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onDel" v-acl="QSPI_FACILITY_DEL_TASK">删除评分任务</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="650" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="Category2" resizable min-width="100" field="category2Name"></ux-table-column>
        <ux-table-column align="center" title="供应商集团名称" resizable min-width="160" field="groupName"></ux-table-column>
        <ux-table-column align="center" title="Facility编号" resizable min-width="120" field="code">
          <template v-slot="scope">
            <el-button type="text" @click="onDetail(scope.row)" v-if="ms_roles.indexOf('QSPI_MASTER_ADMIN')!==-1">{{scope.row.code}}</el-button>
            <p v-else>{{scope.row.code}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Facility名称" resizable min-width="200" field="name"></ux-table-column>
        <ux-table-column align="center" title="状态" resizable min-width="80" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="最新供货月份" resizable min-width="120" field="lastSuppliedMonth"></ux-table-column>
        <ux-table-column align="center" title="最新月供货量" resizable min-width="120" field="lastSuppliedQty"></ux-table-column>
        <ux-table-column align="center" title="备注" resizable min-width="120" field="remark"></ux-table-column>
        <ux-table-column align="center" title="更新日期" resizable min-width="150" field="updateDate"></ux-table-column>
        <ux-table-column align="center" title="更新人" resizable min-width="180" field="updateUser"></ux-table-column>
        <ux-table-column align="center" title="创建日期" resizable min-width="150" field="createDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false" @close="showDetailDialog=false">
      <detailDialog :formData="formData" :selLists="selLists" @closeDialog="closeDialog"></detailDialog>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index';
import commonFunction from "@/utils/dataTableUtils";
import QspiConfigApi from "@/api/qspiConfig/index";
import QBRApi from "@/api/QBR/index";
import detailDialog from './MaintainceFacility';
export default {
  name: '',
  components: {
    IcSelect,
    detailDialog
  },
  data() {
    return {
      categoryList2: [],
      categoryList3: [],
      tableData: [],
      facilityIds: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        name: "",
        groupName: "",
        category2Codes: [],
        category3Codes: [],
        status: "",
      },
      isShow: false,
      showDetailDialog: false,
      formData: null,
      selLists: null,
      ms_roles: null,
      totalCount: 0,
      pages: 1,
    }
  },
  created() {
    this.queryData();
    this.getCategory2Lists()
    this.getCategory3Lists()
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))

  },
  methods: {
    queryData() {
      QspiConfigApi.getQspiFacilityList(this.queryCondition).then(res => {
        console.log('res', res);
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        this.$refs.plxTable.reloadData(res.resultData)
      });
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.queryCondition.category2Codes }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    onDetail(row) {
      QspiConfigApi.getQspiFacilityDetail(row.tmQspiFacilityId).then(res => {
        this.showDetailDialog = true
        this.formData = res.data
        this.selLists = JSON.stringify(this.categoryList2)
      });
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        name: "",
        groupName: "",
        category2Codes: [],
        category3Codes: [],
        status: "",
      }
      this.facilityIds = []
      this.queryData();
    },
    // 选中的行
    selectionChange(row) {
      this.facilityIds = []
      this.multipleSelection = row
      row.forEach(ele => {
        this.facilityIds.push(ele.tmQspiFacilityId)
      });
    },
    onCreate() {
      if (this.facilityIds.length === 0) {
        this.$message.error('请先选择数据后再操作')
        return
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'ACTIVE'
      })
      if (!flag) {
        this.$message.error('只有启用状态的Facility可以生成评分任务。')
        return
      }
      QspiConfigApi.createFactorScore({ facilityIds: this.facilityIds }).then(res => {
        if (res.code === '200') {
          this.$message.success('生成评分成功')
          this.facilityIds = []
          this.queryData();
        }
      });
    },
    onDel() {
      if (this.facilityIds.length === 0) {
        this.$message.error('请先选择数据后再操作')
        return
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'INACTIVE'
      })
      if (!flag) {
        this.$message.error('只有禁用的Facility可以删除评分任务。')
        return
      }
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        QspiConfigApi.removeFactorScore({ facilityIds: this.facilityIds }).then(res => {
          if (res.code === '200') {
            this.$message.success('删除评分成功')
            this.facilityIds = []
            this.queryData();
          }
        });
      })
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    closeDialog() {
      this.showDetailDialog = false
      this.queryData();
      this.formData = {}
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
